import {
  addProduct,
  updateProduct,
  deleteProduct,
  getCart,
  setCart,
  getCartByToken,
  getDeliveryMethods,
  getPaymentMethods,
  setPaymentMethod,
  setDeliveryMethod,
  setDeliveryTime,
  getMyOrder,
  confirmOrder,
  setPreviousOrder,
  addCoupon,
  removeCoupon,
} from '@/api/index'

import { Models } from 'sr-js-lib';

import router from '@/router';

export default {
  namespaced: true,
  state: {
    showCart: false,
    cartProducts:  Models.M_cart(),
    deliveryMethods: [],
    paymentMethods: [],
  },

  getters: {
    getDeliveryMethods(state) {
      return state.deliveryMethods.find(item => item.type == 'DELIVERY') || [];
    },
    getPickupMethods(state) {
      return state.deliveryMethods.find(item => item.type == 'PICKUP') || [];
    }
  },

  mutations: {
    setVisibility(state, boolSate) {
      state.showCart = boolSate;
    },
    setCartProducts(state, cart) {
      state.cartProducts = {
        ...cart
      };
    },
    setDeliveryMethods(state, deliveryMethods) {
      state.deliveryMethods = [
        ...deliveryMethods
      ];
    },
    setPaymentMethods(state, paymentMethods) {
      state.paymentMethods = [
        ...paymentMethods
      ];
    },
  },

  actions: {
    async fnApiAddProduct(context, [storeId, productId, qty]) {
      let body = {
        store_id: storeId,
        // token:1,
      }
      if (context.rootState.user && context.rootState.user.customer_id) {
        body.customer_id = context.rootState.user.customer_id;
      } else {
        body.token = context.state.cartProducts.token || Math.random().toString(36).substr(2);
      }
      await addProduct(productId, body).then(res => {
        context.commit('setCartProducts', res);
      }).catch((e) => {});
    },

    async fnApiUpdateProduct(context, product ) {
      let id = product._id;
      delete product._id;
      let store_id = product.store_id;
      delete product.store_id;
      let body = {
        store_id: store_id,
        token: context.state.cartProducts.token,
        ...product
      }
      await updateProduct(id, body).then(res => {
        context.commit('setCartProducts', res);
      }).catch((e) => {});
    },

    async fnApiDeleteProduct(context, [storeId, productId]) {
      let body = {
        store_id: storeId,
        token: context.state.cartProducts.token
      }
      await deleteProduct(productId, body).then(res => {
        context.commit('setCartProducts', res);
      }).catch((e) => {});
    },
    async fnApiGetCart(context) {
      if (context.rootState.user && context.rootState.user.customer_id && context.state.cartProducts.token && context.state.cartProducts.customer_id == null) {
        await context.dispatch('fnApiSetCart');
      }
      if (context.rootState.user && context.rootState.user.customer_id) {
        await getCart().then(async res => {
          if (res != null) {
            context.commit('setCartProducts', res);
          }
        }).catch((e) => {});
      }
    },

    async fnApiSetCart(context) {
      await setCart(context.state.cartProducts.token).then(res => {
        context.commit('setCartProducts', res);
      }).catch(error => {
        if (error.response.data.error_code == 43) {
          context.commit('setCartProducts', {
            invoice: null,
            store_id: null,
            customer_id: null,
            token: null,
            products: [],
            subtotal: null,
            delivery_price: null,
            total: null,
          });
        }
      })
    },

    async fnApiGetDeliveryMethods(context) {
      await getDeliveryMethods(context.state.cartProducts._id).then(res => {
        context.commit('setDeliveryMethods', res);
      }).catch((e) => {});
    },

    async fnApiPaymentMethods(context) {
      await getPaymentMethods(context.state.cartProducts._id).then(res => {
        context.commit('setPaymentMethods', res);
      }).catch((e) => {});
    },
    async fnApiSetPaymentMethod(context, body) {
      await setPaymentMethod(context.state.cartProducts._id, body).then(res => {
        context.commit('setCartProducts', res);
        context.dispatch('fnApiCofirmOrder', body.notes);
      }).catch((e) => {});
    },

    async fnApiSetDeliveryMethod(context, body) {
      return await setDeliveryMethod(context.state.cartProducts._id, body).then(res => {
        context.commit('setCartProducts', res);
        return res;
      }).catch((e) => {
        if(e.response && e.response.data){
          return e.response.data;
        }
        return null;
      });
    },

    async fnApiDeliveryTime(context, body) {
      await setDeliveryTime(context.state.cartProducts._id, body).then(res => {
        context.commit('setCartProducts', res);
        router.push('/payment/summary');
      }).catch((e) => {});
    },

    async fnAPiGetMyOrder(context) {
      await getMyOrder().then(res => {
        
      }).catch((e) => {});
    },

    async fnApiCofirmOrder(context, notes) {
      await confirmOrder(context.state.cartProducts._id, {
        notes
      }).then(res => {
        context.commit('setCartProducts', res);
        router.push('/payment/order-finished?hide_return=true');
      }).catch((e) => {})
    },

    async fnApiPreviousOrder(context, orderId) {
      await setPreviousOrder(orderId).then(res => {
        context.commit('setCartProducts', res.cart);
        context.commit('setVisibility', true);
      }).catch((e) => {})
    },

    async fnApiAddCoupon(context, body) {
      return await addCoupon(context.state.cartProducts._id, body).then(res => {
        context.commit('setCartProducts', res);
        return true;
      }).catch((e) => {
        return false;
      });
    },

    async fnApiRemoveCoupon(context) {
      await removeCoupon(context.state.cartProducts._id).then(res => {
        context.commit('setCartProducts', res);
      }).catch((e) => {});
    },

  },
};
